//Generated File 
export default class CustomRepLaunchType{
	static readonly DirectInNewPage = `DirectInNewPage`;
	static readonly DirectInPopup = `DirectInPopup`;
	static readonly ParamsInNewPage = `ParamsInNewPage`;
	static readonly ParamsInPopup = `ParamsInPopup`;
	static readonly Print = `Print`;
}
